import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DisplayEvidencia {
	display: boolean;
	path: {
		rutaKey: string;
		cursoKey: string;
		tipoKey: string;
		tipoActividad: 'grupal' | 'individual' | 'curso';
		numeroSesion: number;
		numeroRutaSesion: number;
		isVistaTablaEquipo: boolean;
		grupoKey: string | undefined;
	} | null;
}

const initialState: DisplayEvidencia = {
	display: false,
	path: null
};

const displayEvidenciaSegSlice = createSlice({
	name: 'displayEvidenciaSeg',
	initialState,
	reducers: {
		setDisplayEvidenciaSeg: (state, action: PayloadAction<DisplayEvidencia>) => {
			return action.payload;
		},
		updatePositionDisplayEvidenciaSeg: (state, action) => {
			if (!state.path) return state;
			const direction = action.payload;
			return {
				...state,
				display: true,
				path: {
					...state.path,
					numeroSesion: direction
				}
			};
		},
		updateStudentDisplayEvidenciaSeg: (state, action) => {
			if (!state.path) return state;
			const { estudianteKey: newKey, grupoKey: newGrupoKey } = action.payload;
			return {
				...state,
				display: true,
				path: {
					...state.path,
					tipoKey: newKey,
					grupoKey: newGrupoKey
				}
			};
		},
		resetDisplayEvidenciaSeg: () => {
			return initialState;
		}
	}
});

export const {
	setDisplayEvidenciaSeg,
	updatePositionDisplayEvidenciaSeg,
	resetDisplayEvidenciaSeg,
	updateStudentDisplayEvidenciaSeg
} = displayEvidenciaSegSlice.actions;

export default displayEvidenciaSegSlice.reducer;
